import { IconTypes } from "../models/icon-types";

class IconTypeMapper {
    public mapItem(icon: string): IconTypes {
        return (<any>IconTypes)[icon] ?? IconTypes.Default;
    }
}

export default new IconTypeMapper();